<template>
  <Content class="col-span-full" :title="$route.name">
    <Notice class="mb-8">
      کلمه عبور جدید باید حداقل
      <span class="bg-white rounded-md py-1 px-2 bg-opacity-90 border border-gray-200"> 8 کاراکتر</span>
      ، شامل
      <span class="bg-white rounded-md py-1 px-2 bg-opacity-90 border border-gray-200">حروف کوچک و بزرگ</span>
      و
      <span class="bg-white rounded-md py-1 px-2 bg-opacity-90 border border-gray-200">اعداد</span>
      باشد.

    </Notice>
    <el-form @keyup.enter.native="submitForm('ruleForm')" :model="ruleForm" :rules="rules" label-position="top"
      ref="ruleForm" label-width="120px" class="
        carpo-form demo-ruleForm
      ">
      <el-form-item :label="$t('CURRENT_PASSWORD')" prop="old_password">
        <el-input type="password" v-model="ruleForm.old_password" autocomplete="off" show-password
          class="left-inputs"></el-input>
      </el-form-item>
      <div class="hidden md:flex md:col-span-1 lg:col-span-2 xl:col-span-3"></div>

      <el-form-item :label="$t('NEW_PASSWORD')" prop="new_password">
        <el-input type="password" v-model="ruleForm.new_password" autocomplete="off" show-password
          class="left-inputs"></el-input>
      </el-form-item>

      <el-form-item :label="$t('REPEAT_NEW_PASS')" prop="confirmed_password">
        <el-input type="password" v-model="ruleForm.confirmed_password" autocomplete="off" show-password
          class="left-inputs"></el-input>
      </el-form-item>

      <el-form-item class="flex justify-end col-span-full mt-4">
        <el-popconfirm :class="{ 'ml-4': $i18n.locale == 'fa', 'mr-4': $i18n.locale != 'fa' }"
          :confirm-button-text="$t('YES')" :cancel-button-text="$t('NO')" icon="el-icon-info" icon-color="red"
          :title="$t('DELETE_FORM')" @confirm="resetForm('ruleForm')">
          <el-button slot="reference" class="ml-2" type="warning" plain>
            {{ $t('RESET_FORM_BTN') }}
          </el-button>
        </el-popconfirm>
        <el-button type="success" @click="submitForm('ruleForm')">
          {{ $t('SUBMIT') }}
        </el-button>
      </el-form-item>
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from "@/mixins/resetForm";
import { change_password } from '@/api/setting';
import Notice from '@/components/elements/notice';

export default {
  mixins: [resetForm],
  data() {
    var newpass = (rule, value, callback) => {
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(new Error("کلمه عبور باید حداقل 8 کاراکتر باشد و شامل حروف کوچک و بزرگ و اعداد و کاراکترهای غیر الزامی باشد"));
      }
    };
    var confirmed_pass = (rule, value, callback) => {
      if (this.ruleForm.new_password != value) {
        callback(new Error('کلمه عبور و تکرار کلمه عبور جدید باید یکسان باشد.'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        old_password: '',
        new_password: '',
        confirmed_password: ''
      },
      rules: {
        old_password: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("CURRENT_PASSWORD"),
            }),
            trigger: "blur",
          },
        ],
        new_password: [
          { required: true, trigger: 'blur', validator: newpass }
        ],
        confirmed_password: [
          { required: true, trigger: 'blur', validator: confirmed_pass }
        ],
      },
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            old_password: this.ruleForm.old_password,
            new_password: this.ruleForm.new_password,
            confirmed_password: this.ruleForm.confirmed_password,
          };
          change_password.api(actionPayload).then(res => {
            if (res) {
              this.$notify.success({
                title: this.$route.name + " " + this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg'

              });
              this.$router.push({ path: "/" + this.$i18n.locale + '/dashboard' });
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg'
          });
          return false;
        }
      });
    },

  },
  components: {
    Notice
  }

};
</script>
<style scoped>